import React from "react";
import initFontAwesome from "./utils/initFontAwesome";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import PageRoutes from "./pageRoutes";
import SnackbarWrapper from "./components/SnackbarWrapper";
import { ThemeProvider } from "./context/ThemeContext";

initFontAwesome();

const App = () => {
  return (
    <ThemeProvider>
      <Provider store={store}>
        <SnackbarWrapper />
        <PageRoutes />
      </Provider>
    </ThemeProvider>
  );
};

export default App;
